var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { attrs: { title: "Updates" } }, [
    _c("div", { staticClass: "text-gray-600 text-sm mb-4" }, [
      _vm._v("Latest system changes and feature launches")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "space-y-3" }, [
      _c("div", [
        _c("div", { staticClass: "flex items-center justify-between" }, [
          _c("span", { staticClass: "font-semibold text-gray-900" }, [
            _vm._v("SLA Uptime Improved")
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "bg-gray-100 text-gray-700 rounded-full px-2 py-0.5 text-xs"
            },
            [_vm._v("Today")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-gray-500 text-xs" }, [
          _vm._v("Uptime commitment raised to 99.99% for all production plans.")
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "flex items-center justify-between" }, [
          _c("span", { staticClass: "font-semibold text-gray-900" }, [
            _vm._v("Feature Deployment")
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "bg-gray-100 text-gray-700 rounded-full px-2 py-0.5 text-xs"
            },
            [_vm._v("Yesterday")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-gray-500 text-xs" }, [
          _vm._v("Real-time analytics now available for all users.")
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "flex items-center justify-between" }, [
          _c("span", { staticClass: "font-semibold text-gray-900" }, [
            _vm._v("Security Audit Passed")
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "bg-gray-100 text-gray-700 rounded-full px-2 py-0.5 text-xs"
            },
            [_vm._v("2 days ago")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-gray-500 text-xs" }, [
          _vm._v("SOC2 Type II certification achieved for this year.")
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3540ebd9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3540ebd9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/StatCards/ReccomendationsRow/UpdatesCard.vue
// module id = null
// module chunks = 